//FOR FULL URL

// import {
//   createBrowserHistory,
//   createPath,
//   parsePath,
//   Location,
//   To,
// } from "history";
// import type { ComponentProps } from "react";
// import type { unstable_HistoryRouter } from "react-router-dom";
// import { encryptUrl, decryptUrl } from "./urlCrypto";

// // The exact History type your installed react-router-dom expects
// type RouterHistory = ComponentProps<typeof unstable_HistoryRouter>["history"];

// const PREFIX = "/e/";
// const PASSTHROUGH = new Set(["/"]); // paths that stay readable (login page)

// const base = createBrowserHistory();

// /** real "to" -> what the address bar should show */
// export function encodeTo(to: To): string {
//   const path = typeof to === "string" ? to : createPath(to);
//   const { pathname = "/", search = "", hash = "" } = parsePath(path);

//   if (PASSTHROUGH.has(pathname) && !search && !hash) return path;
//   if (pathname.startsWith(PREFIX)) return path; // already encrypted

//   return `${PREFIX}${encryptUrl(`${pathname}${search}${hash}`)}`;
// }

// const cache = new WeakMap<Location, Location>();

// /** what's in the address bar -> real location the app should see */
// function decodeLocation(loc: Location): Location {
//   if (!loc.pathname.startsWith(PREFIX)) return loc; // plain URL, pass through

//   const cached = cache.get(loc);
//   if (cached) return cached;

//   const plain = decryptUrl(loc.pathname.slice(PREFIX.length));
//   const parsed = parsePath(plain ?? "/"); // bad token -> home/login
//   const decoded: Location = {
//     ...loc,
//     pathname: parsed.pathname || "/",
//     search: parsed.search || "",
//     hash: parsed.hash || "",
//   };
//   cache.set(loc, decoded);
//   return decoded;
// }

// // If someone lands on a plain URL (bookmark, SSO link, <a href>), hide it immediately.
// {
//   const { pathname, search, hash, state } = base.location;
//   if (!pathname.startsWith(PREFIX) && !PASSTHROUGH.has(pathname)) {
//     base.replace(encodeTo({ pathname, search, hash }), state);
//   }
// }

// const history = {
//   get action() {
//     return base.action;
//   },
//   get location() {
//     return decodeLocation(base.location);
//   },
//   createHref: (to: To) => base.createHref(encodeTo(to)),
//   // Required by newer react-router versions
//   createURL: (to: To) =>
//     new URL(encodeTo(to), window.location.origin),
//   encodeLocation: (to: To) => {
//     const p = typeof to === "string" ? parsePath(to) : to;
//     return {
//       pathname: p.pathname || "",
//       search: p.search || "",
//       hash: p.hash || "",
//     };
//   },
//   push: (to: To, state?: any) => base.push(encodeTo(to), state),
//   replace: (to: To, state?: any) => base.replace(encodeTo(to), state),
//   go: (n: number) => base.go(n),
//   back: () => base.back(),
//   forward: () => base.forward(),
//   listen: (listener: (update: any) => void) =>
//     base.listen(({ action, location }) =>
//       listener({ action, location: decodeLocation(location) })
//     ),
//   block: (blocker: any) => base.block(blocker),
// };

// export const secureHistory = history as unknown as RouterHistory;

// /* ---------- helpers for code that bypasses React Router ---------- */

// /** Use instead of: window.location.href = "/STUDENT/MSR/Profile?x=1" */
// export const toSecureUrl = (plainPath: string) =>
//   `${window.location.origin}${encodeTo(plainPath)}`;

// /** Use instead of reading window.location.pathname / search / hash */
// export const getRealLocation = () => history.location;


//FOR ONLY QUERY PARAMS

// import {
//   createBrowserHistory,
//   createPath,
//   parsePath,
//   Location,
//   To,
// } from "history";
// import type { ComponentProps } from "react";
// import type { unstable_HistoryRouter } from "react-router-dom";
// import { encryptUrl, decryptUrl } from "./urlCrypto";

// // The exact History type your installed react-router-dom expects
// type RouterHistory = ComponentProps<typeof unstable_HistoryRouter>["history"];

// const PARAM = "e"; // the single query param that carries the encrypted query string

// const base = createBrowserHistory();

// /** "?a=1&b=2" -> "?e=<token>" (empty or already-encrypted search is left alone) */
// function encodeSearch(search: string): string {
//   if (!search || search === "?") return "";
//   const params = new URLSearchParams(search);
//   if (params.has(PARAM) && Array.from(params.keys()).length === 1) return search;
//   return `?${PARAM}=${encryptUrl(search)}`;
// }

// /** "?e=<token>" -> "?a=1&b=2" (bad or tampered token -> empty query) */
// function decodeSearch(search: string): string {
//   if (!search) return search;
//   const params = new URLSearchParams(search);
//   const token = params.get(PARAM);
//   if (!token) return search; // plain query, pass through
//   const plain = decryptUrl(token);
//   return plain && plain.startsWith("?") ? plain : "";
// }

// /** real "to" -> what the address bar should show (path stays readable) */
// export function encodeTo(to: To): string {
//   const path = typeof to === "string" ? to : createPath(to);
//   const { pathname = "/", search = "", hash = "" } = parsePath(path);
//   return `${pathname}${encodeSearch(search)}${hash}`;
// }

// const cache = new WeakMap<Location, Location>();

// /** what's in the address bar -> real location the app should see */
// function decodeLocation(loc: Location): Location {
//   if (!loc.search) return loc;

//   const cached = cache.get(loc);
//   if (cached) return cached;

//   const decoded: Location = { ...loc, search: decodeSearch(loc.search) };
//   cache.set(loc, decoded);
//   return decoded;
// }

// // If someone lands on a plain URL with a query (bookmark, SSO link, <a href>),
// // encrypt the query in the address bar immediately.
// {
//   const { pathname, search, hash, state } = base.location;
//   if (search && !new URLSearchParams(search).has(PARAM)) {
//     base.replace(encodeTo({ pathname, search, hash }), state);
//   }
// }

// const history = {
//   get action() {
//     return base.action;
//   },
//   get location() {
//     return decodeLocation(base.location);
//   },
//   createHref: (to: To) => base.createHref(encodeTo(to)),
//   // Required by newer react-router versions
//   createURL: (to: To) => new URL(encodeTo(to), window.location.origin),
//   encodeLocation: (to: To) => {
//     const p = typeof to === "string" ? parsePath(to) : to;
//     return {
//       pathname: p.pathname || "",
//       search: p.search || "",
//       hash: p.hash || "",
//     };
//   },
//   push: (to: To, state?: any) => base.push(encodeTo(to), state),
//   replace: (to: To, state?: any) => base.replace(encodeTo(to), state),
//   go: (n: number) => base.go(n),
//   back: () => base.back(),
//   forward: () => base.forward(),
//   listen: (listener: (update: any) => void) =>
//     base.listen(({ action, location }) =>
//       listener({ action, location: decodeLocation(location) })
//     ),
//   block: (blocker: any) => base.block(blocker),
// };

// export const secureHistory = history as unknown as RouterHistory;

// /* ---------- helpers for code that bypasses React Router ---------- */

// /** Use instead of: window.location.href = "/STUDENT/MSR/Profile?x=1" */
// export const toSecureUrl = (plainPath: string) =>
//   `${window.location.origin}${encodeTo(plainPath)}`;

// /** Use instead of reading window.location.search directly (it's encrypted now) */
// export const getRealLocation = () => history.location;



//FOR FIXING QUESTION PAGE ISSUE

import {
  createBrowserHistory,
  createPath,
  parsePath,
  Location,
  To,
} from "history";
import type { ComponentProps } from "react";
import type { unstable_HistoryRouter } from "react-router-dom";
import { encryptUrl, decryptUrl } from "./urlCrypto";

// The exact History type your installed react-router-dom expects
type RouterHistory = ComponentProps<typeof unstable_HistoryRouter>["history"];

const PARAM = "e"; // the single query param that carries the encrypted query string

// Kill switch: set REACT_APP_ENCRYPT_QUERY=false in .env to turn encryption off entirely
const ENABLED = process.env.REACT_APP_ENCRYPT_QUERY !== "false";

/* ------------------------------------------------------------------ */
/* Native URLSearchParams (captured BEFORE we patch it; HMR-safe)      */
/* ------------------------------------------------------------------ */
const NativeURLSearchParams: typeof URLSearchParams =
  (window.URLSearchParams as any).__native || window.URLSearchParams;

/**
 * "?e=<token>" -> "?a=1&b=2"
 * Returns null when the string is NOT a valid encrypted query
 * (plain query, bad token, tampered token, empty...). Never throws.
 */
function tryDecodeSearch(search: string): string | null {
  try {
    if (!search) return null;
    const params = new NativeURLSearchParams(search);
    const keys = Array.from(params.keys());
    if (keys.length !== 1 || keys[0] !== PARAM) return null;
    const token = params.get(PARAM);
    if (!token) return null;
    const plain = decryptUrl(token);
    return plain && plain.startsWith("?") ? plain : null;
  } catch {
    return null;
  }
}

/* ------------------------------------------------------------------ */
/* Patch URLSearchParams so existing                                   */
/*   new URLSearchParams(window.location.search)                       */
/* keeps working in every page without editing them.                   */
/* ------------------------------------------------------------------ */
if (ENABLED && !(window.URLSearchParams as any).__secure) {
  const Patched: any = function (init?: any) {
    if (typeof init === "string") {
      const decoded = tryDecodeSearch(init);
      if (decoded !== null) init = decoded;
    }
    return new NativeURLSearchParams(init);
  };
  Patched.prototype = NativeURLSearchParams.prototype; // instanceof keeps working
  Patched.__secure = true;
  Patched.__native = NativeURLSearchParams;
  window.URLSearchParams = Patched;
}

/* ------------------------------------------------------------------ */
/* History wrapper                                                     */
/* ------------------------------------------------------------------ */
const base = createBrowserHistory();

/** "?a=1&b=2" -> "?e=<token>" (empty or already-encrypted search is left alone) */
function encodeSearch(search: string): string {
  if (!ENABLED) return search;
  if (!search || search === "?") return "";
  if (tryDecodeSearch(search) !== null) return search; // already encrypted
  return `?${PARAM}=${encryptUrl(search)}`;
}

/** real "to" -> what the address bar should show (path stays readable) */
export function encodeTo(to: To): string {
  const path = typeof to === "string" ? to : createPath(to);
  const { pathname = "/", search = "", hash = "" } = parsePath(path);
  return `${pathname}${encodeSearch(search)}${hash}`;
}

const cache = new WeakMap<Location, Location>();

/** what's in the address bar -> real location the app should see */
function decodeLocation(loc: Location): Location {
  if (!ENABLED || !loc.search) return loc;

  const cached = cache.get(loc);
  if (cached) return cached;

  const decodedSearch = tryDecodeSearch(loc.search);
  const decoded: Location =
    decodedSearch === null ? loc : { ...loc, search: decodedSearch };
  cache.set(loc, decoded);
  return decoded;
}

// If someone lands on a plain URL with a query (reload, bookmark, SSO link, <a href>),
// encrypt the query in the address bar immediately.
if (ENABLED) {
  try {
    const { pathname, search, hash, state } = base.location;
    if (search && tryDecodeSearch(search) === null) {
      base.replace(encodeTo({ pathname, search, hash }), state);
    }
  } catch {
    /* never block app start */
  }
}

const history = {
  get action() {
    return base.action;
  },
  get location() {
    return decodeLocation(base.location);
  },
  createHref: (to: To) => base.createHref(encodeTo(to)),
  // Required by newer react-router versions
  createURL: (to: To) => new URL(encodeTo(to), window.location.origin),
  encodeLocation: (to: To) => {
    const p = typeof to === "string" ? parsePath(to) : to;
    return {
      pathname: p.pathname || "",
      search: p.search || "",
      hash: p.hash || "",
    };
  },
  push: (to: To, state?: any) => base.push(encodeTo(to), state),
  replace: (to: To, state?: any) => base.replace(encodeTo(to), state),
  go: (n: number) => base.go(n),
  back: () => base.back(),
  forward: () => base.forward(),
  listen: (listener: (update: any) => void) =>
    base.listen(({ action, location }) =>
      listener({ action, location: decodeLocation(location) })
    ),
  block: (blocker: any) => base.block(blocker),
};

export const secureHistory = history as unknown as RouterHistory;

/* ---------- helpers for code that bypasses URLSearchParams ---------- */

/** Use instead of: window.location.href = "/STUDENT/MSR/Profile?x=1" */
export const toSecureUrl = (plainPath: string) =>
  `${window.location.origin}${encodeTo(plainPath)}`;

/** Real (decrypted) query string, e.g. "?folder=abc&name=X". Use instead of window.location.search */
export const getRealSearch = (): string =>
  tryDecodeSearch(window.location.search) ?? window.location.search;

export const getRealLocation = () => history.location;